import { render, staticRenderFns } from "./promotions-detail.vue?vue&type=template&id=0db1c08e&scoped=true&"
import script from "./promotions-detail.vue?vue&type=script&lang=js&"
export * from "./promotions-detail.vue?vue&type=script&lang=js&"
import style0 from "./promotions-detail.vue?vue&type=style&index=0&id=0db1c08e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db1c08e",
  null
  
)

export default component.exports